<div [ngClass]="{
    'bevel--left': bevelPosition === 'left',
    'bevel--right': bevelPosition === 'right',
    'bevel--top': bevelPosition === 'top',
    'bevel--top-sharp': bevelPosition === 'top-sharp'
  }" class="bevel-container p-5 h-full">
  <ng-content></ng-content>
</div>